export default {"src":"/_next/static/media/trademark.e4e5f057.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};